// import '../App.css';

import { Link } from 'react-router-dom';
import classes from './YesNoPopup.module.css';
import '../css_styles/button_styles.css'



function YesNoPopup(props) {
    return (
    <div className = {classes.yes_no_popup} style = { {marginTop: props.ypos} } >
          <div style = {{height: 'min-content', marginTop: '20px', marginBottom: '20px', width:'80%', textAlign: 'center', position: 'relative', left: '50%', transform: 'translate(-50%,0% )'}}>
              {props.children}
              <div className = {classes.buttonContainer} >
                <button className={'tableButton'} onClick={props.handleYes}>yes</button>
                <Link style={{textDecoration: 'none'}} to={props.linkNo} className={'tableButton'} onClick={props.handleNo}>no</Link>
              </div>
         </div>
    </div>
    );
}

export default YesNoPopup;

